import React from 'react';
import { Delete as DeleteIcon, Dot } from '@icon-park/react';
import './styles/LinkEditor.css';

function LinkEditor({ data, onUpdate }) {
  const handleAddLink = () => {
    const newLinks = [
      ...(data.links || []),
      { icon: '', name: '', url: 'http://', order: (data.links?.length || 0) + 1 }
    ];
    onUpdate({ ...data, links: newLinks });
  };

  const handleUpdateLink = (index, field, value) => {
    const newLinks = [...data.links];
    newLinks[index][field] = value;
    onUpdate({ ...data, links: newLinks });
  };

  const handleDeleteLink = (index) => {
    const newLinks = data.links.filter((_, i) => i !== index);
    onUpdate({ ...data, links: newLinks });
  };

  const handleIconUpload = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        handleUpdateLink(index, 'icon', e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="link-editor-container">
      <h3 className="editor-title-link">超链接</h3>

      {/* 布局与样式设置 */}
      <div style={{ display: 'grid', gap: 12, marginBottom: 12 }}>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
          <label>布局：</label>
          <select value={data.layout || 'list'} onChange={(e) => onUpdate({ ...data, layout: e.target.value })}>
            <option value="list">列表</option>
            <option value="card-grid">卡片网格</option>
            <option value="horizontal">横向行</option>
          </select>
          <label>文字颜色</label>
          <input type="color" value={(data.cardStyle && data.cardStyle.textColor) || '#202124'} onChange={(e) => onUpdate({ ...data, cardStyle: { ...(data.cardStyle || {}), textColor: e.target.value } })} />
          <label>卡片背景</label>
          <input type="color" value={(data.cardStyle && data.cardStyle.bgColor) || '#f8f9fa'} onChange={(e) => onUpdate({ ...data, cardStyle: { ...(data.cardStyle || {}), bgColor: e.target.value } })} />
          <label>边框色</label>
          <input type="color" value={(data.cardStyle && data.cardStyle.borderColor) || '#e8eaed'} onChange={(e) => onUpdate({ ...data, cardStyle: { ...(data.cardStyle || {}), borderColor: e.target.value } })} />
          <label>边框宽(px)</label>
          <input type="number" min="0" max="8" value={(data.cardStyle && data.cardStyle.borderWidth) || 1} onChange={(e) => onUpdate({ ...data, cardStyle: { ...(data.cardStyle || {}), borderWidth: Number(e.target.value) } })} />
          <label>圆角(px)</label>
          <input type="number" min="0" max="24" value={(data.cardStyle && data.cardStyle.radius) || 8} onChange={(e) => onUpdate({ ...data, cardStyle: { ...(data.cardStyle || {}), radius: Number(e.target.value) } })} />
          <label><input type="checkbox" checked={!(data.cardStyle && data.cardStyle.shadow === false)} onChange={(e) => onUpdate({ ...data, cardStyle: { ...(data.cardStyle || {}), shadow: e.target.checked } })} /> 阴影</label>
        </div>
      </div>
      
      <div className="link-table">
        <div className="table-header">
          <div className="col-icon">示例图片</div>
          <div className="col-name">示例名称</div>
          <div className="col-url">链接</div>
          <div className="col-order">排序</div>
        </div>
        
        <div className="table-body">
          {data.links && data.links.map((link, index) => (
            <div key={index} className="table-row">
              <div className="col-icon">
                <input
                  type="file"
                  id={`icon-upload-${index}`}
                  accept="image/*"
                  onChange={(e) => handleIconUpload(index, e)}
                  style={{ display: 'none' }}
                />
                <label htmlFor={`icon-upload-${index}`} className="icon-upload-label">
                  {link.icon ? (
                    <img src={link.icon} alt="图标" className="link-icon-preview" />
                  ) : (
                    <div className="icon-placeholder"><Dot theme="outline" size={16} fill="#999" strokeWidth={3} /></div>
                  )}
                </label>
              </div>
              <div className="col-name">
                <input
                  type="text"
                  value={link.name}
                  onChange={(e) => handleUpdateLink(index, 'name', e.target.value)}
                  placeholder="示例名称"
                  className="table-input"
                />
              </div>
              <div className="col-url">
                <input
                  type="text"
                  value={link.url}
                  onChange={(e) => handleUpdateLink(index, 'url', e.target.value)}
                  placeholder="http://"
                  className="table-input"
                />
              </div>
              <div className="col-order">
                <input
                  type="number"
                  value={link.order}
                  onChange={(e) => handleUpdateLink(index, 'order', parseInt(e.target.value))}
                  className="table-input-small"
                />
              </div>
              <button 
                className="delete-row-btn"
                onClick={() => handleDeleteLink(index)}
              >
                <DeleteIcon theme="outline" size={14} fill="#333" strokeWidth={3} />
              </button>
            </div>
          ))}
        </div>
        
        <div className="table-footer">
          <button className="add-link-btn" onClick={handleAddLink}>
            添加
          </button>
        </div>
      </div>
    </div>
  );
}

export default LinkEditor;
